const Academic = () => import('../views/ResourceManage/Academy/index.vue');
const Brand = () => import('../views/ResourceManage/Brand/index.vue');
const Question = () => import('../views/ResourceManage/Question/index.vue');
const Papercategory = () => import('../views/ResourceManage/Papercategory/index.vue');
const Template = () => import('../views/ResourceManage/Template/index.vue');
const Sample = () => import('../views/ResourceManage/Sample/index.vue');
const PromoteFeed = () => import('../views/ResourceManage/PromoteFeed/index.vue');
const ArticleList = () => import('../views/ResourceManage/ArticleList/index.vue');
const ArticleAdd = () => import('../views/ResourceManage/ArticleList/pages/index.vue');
const Video = () => import('../views/ResourceManage/Video/index.vue');
const VideoAdd = () => import('../views/ResourceManage/Video/pages/index.vue');
const Answer = () => import('../views/ResourceManage/QuestionAndAnswer/index.vue');
const AnswerList = () => import('../views/ResourceManage/QuestionAndAnswer/pages/index.vue');
const Testpaper = () => import('../views/ResourceManage/TestPaper/index.vue');
const TopicList=() => import('../views/ResourceManage/TestPaper/pages/index.vue');
export default [
  {
    path: '/question',
    name: '调研题库',
    component: Question,
    meta: [{ name: '调研题库' }],
  },
  {
    path: '/papercategory',
    name: '试卷类别',
    component: Papercategory,
    meta: [{ name: '试卷类别' }],
  },
  {
    path: '/template',
    name: '调研模板',
    component: Template,
    meta: [{ name: '调研模板' }],
  },
  {
    path: '/academic',
    name: '学术资料',
    component: Academic,
    meta: [{ name: '学术资料' }],
  },
  {
    path: '/brand',
    name: '品牌提示物',
    component: Brand,
    meta: [{ name: '品牌提示物' }],
  },
  {
    path: '/sample',
    name: '样品赠品',
    component: Sample,
    meta: [{ name: '样品赠品' }],
  },

  {
    name: '文章列表',
    path: '/articlelist',
    component: ArticleList,
    meta: [{ name: '文章列表' }],
  },
  {
    name: '新增资讯',
    path: '/article/add',
    component: ArticleAdd,
    meta: [{ name: '文章管理', path: '/articlelist' }, {name: '新增资讯'}],
  },
  {
    name: '编辑资讯',
    path: '/article/edit',
    component: ArticleAdd,
    meta: [{ name: '文章资讯', path: '/articlelist' }, {name: '编辑资讯'}],
  },
  {
    name: '视频管理',
    path: '/video',
    component: Video,
    meta: [{ name: '视频管理' }],
  },
  {
    name: '新增视频',
    path: '/video/add',
    component: VideoAdd,
    meta: [{ name: '视频管理', path: '/video' }, {name: '新增视频'}],
  },
  {
    name: '编辑视频',
    path: '/video/edit',
    component: VideoAdd,
    meta: [{ name: '视频管理', path: '/video' }, {name: '编辑视频'}],
  },
  {
    menuName: '推广反馈',
    path: '/promoteFeed',
    component: PromoteFeed,
    meta: [{ name: '推广反馈' }],
  },
  {
    menuName: '提问评价',
    path: '/answer',
    component: Answer,
    meta: [{ name: '提问评价' }],
  },
  {
    menuName: '回复列表',
    path: '/answer/list',
    component: AnswerList,
    meta: [{ name: '提问评价', path: '/answer' }, { name: '回复列表' }],
  },
  {
    menuName: '试卷管理',
    path: '/testpaper',
    component: Testpaper,
    meta: [{ name: '试卷管理' }],
  },
  {
    menuName: '题目列表',
    path: '/testpaper/list',
    component: TopicList,
    meta: [{ name: '试卷管理', path: '/testpaper' }, { name: '题目列表' }],
  },
];
